// ─── Numéro de téléphone dans le header sticky ───────────────────────────────
(function () {
  var PHONE_CLASS = 'header-phone-sticky';
  var PHONE_HTML =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" width="15" height="15" style="margin-right:5px">' +
    '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" ' +
    'd="M3.5 4.5c0-.5.4-1 1-1h2l1.5 3.5-1.5 1c.6 1.5 1.5 2.8 3 3.5l1-1.5 3.5 1.5v2c0 .6-.5 1-1 1C6.5 18 2 13.5 2 7.5c0-.5.4-1 1-1z"/>' +
    '</svg>450 471-8929';

  function addPhone() {
    var rightCol = document.querySelector('.header__column--right');
    var searchBtn = rightCol && rightCol.querySelector('search-button');
    if (!rightCol || !searchBtn || rightCol.querySelector('.' + PHONE_CLASS)) return;

    // ↓ Injecte le style hover une seule fois
    if (!document.getElementById('header-phone-sticky-style')) {
      var style = document.createElement('style');
      style.id = 'header-phone-sticky-style';
      style.textContent = '.' + PHONE_CLASS + ':hover { color: rgb(1, 82, 157) !important; }';
      document.head.appendChild(style);
    }

    var a = document.createElement('a');
    a.href = 'tel:+14504718929';
    a.className = PHONE_CLASS + ' mobile:hidden size-style button button--ANk5oQkd6TSszZlN4M__button_xzeNbx';
    a.setAttribute('style',
      '--size-style-width: fit-content;' +
      '--size-style-height: ;' +
      '--size-style-width-mobile: fit-content;' +
      '--size-style-width-mobile-min: fit-content;' +
      'color: #FFFFFF;'
    );
    a.innerHTML = PHONE_HTML;
    rightCol.insertBefore(a, searchBtn);
  }

  // 1. Chargement initial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(addPhone, 0); });
  } else {
    setTimeout(addPhone, 0);
  }

  // 2. Après chaque transition de page (View Transitions API)
  window.addEventListener('pagereveal', function () { setTimeout(addPhone, 0); });

  // 3. Shopify theme editor
  document.addEventListener('shopify:section:load', addPhone);

  // 4. MutationObserver ciblé sur le header (pas le body entier)
  function setupObserver() {
    var header = document.querySelector('.header-section, #header-component');
    if (!header) return;
    new MutationObserver(function () {
      if (!document.querySelector('.' + PHONE_CLASS)) addPhone();
    }).observe(header, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupObserver);
  } else {
    setupObserver();
  }
})();